import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

function QuickActions({ actions, onClick }) {
  return (
    <Stack spacing={1.5}>
      <Text weight="medium" gutterBottom size="sm" color="tertiary">
        <FormattedMessage id="businessProfile.aiAssistant.quickLinksTitle" />
      </Text>
      <Stack spacing={1}>
        {actions.map((action) => (
          <Button
            key={action}
            variant="card"
            onClick={() => onClick(action)}
            size="sm"
            fullWidth
            sx={{ justifyContent: 'flex-start' }}
          >
            <FormattedMessage id={action} />
          </Button>
        ))}
      </Stack>
    </Stack>
  );
}

QuickActions.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default QuickActions;
